import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=6490afd4&scoped=true&"
import script from "./CarouselList.vue?vue&type=script&lang=js&"
export * from "./CarouselList.vue?vue&type=script&lang=js&"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=6490afd4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490afd4",
  null
  
)

export default component.exports